import TeamplanCardSkeleton from './teamplan-card-skeleton'

export default TeamplanCardSkeleton
